import React from 'react'
import { Link } from '@klarna/bubble-ui'
import { useMobileSDKContext } from '../../services/MobileSDKMessaging/MobileSDKMessagingContext'

type ExternalLinkProps = {
  href: string
  children: React.ReactNode
  ariaLabel?: string
  textToken?: string
  colorToken?: string
  isUnderlined?: boolean
};

const ExternalLink: React.FC<ExternalLinkProps> = ({
  href,
  children,
  ariaLabel,
  textToken,
  colorToken,
  isUnderlined = true,
}) => {
  const { isMobileSDKContext, messagingSDK } = useMobileSDKContext()

  return (
    <Link
      rel="noopener noreferrer"
      target="_blank"
      href={href}
      textToken={textToken}
      colorToken={colorToken}
      isUnderlined={isUnderlined}
      ariaLabel={ariaLabel}
      onPress={(e: React.MouseEvent) => {
        if (isMobileSDKContext && messagingSDK) {
          e.preventDefault()
          try {
            if (messagingSDK.isSandboxedInternalBrowserSupported()) {
              messagingSDK.showSandboxedInternalBrowser(href)
            } else {
              messagingSDK.openExternalBrowser(href)
            }
          } catch (error) {
            window.open(href, '_blank')
          }
        }
      }}
    >
      {children}
    </Link>
  )
}

export default ExternalLink
